"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/@material-ui/utils/ponyfillGlobal.js
// module id = 409
// module chunks = 0